export default {
  en: {
    endUsers: {
      name: '@:untranslated.userType.endUsers',
      description: 'End-users for self-service portal and FinOps/GreenOps analysis',
    },
    platformTeams: {
      name: '@:untranslated.userType.platformTeams',
      description: 'Platform teams - CoE administrators of the platform',
    },
  },
  es: {
    endUsers: {
      name: '@:untranslated.userType.endUsers',
      description: 'Usuarios finales para el portal de autoservicio y análisis FinOps/GreenOps',
    },
    platformTeams: {
      name: '@:untranslated.userType.platformTeams',
      description: 'Equipos de plataforma - Administradores de CoE de la plataforma',
    },
  },
  fr: {
    endUsers: {
      name: '@:untranslated.userType.endUsers',
      description: `Utilisateurs finaux pour le portail en libre-service et l'analyse FinOps/GreenOps`,
    },
    platformTeams: {
      name: '@:untranslated.userType.platformTeams',
      description: 'Équipes de la plateforme - Administrateurs CoE de la plateforme',
    },
  },
}
